import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "text"]

  pick() {
    this.textTarget.value = this.pickerTarget.value.toUpperCase()
  }

  type() {
    const value = this.textTarget.value.trim()
    if (/^#[0-9A-F]{6}$/i.test(value)) this.pickerTarget.value = value
  }
}
